import { compose } from "redux";
import component from "./index.component";
import withCurrentUser from "lib/containers/withCurrentUser";

export default compose(withCurrentUser)(component);
